var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLink = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "#1B1F23",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M21.083 12.5c0 3.222-3.003 5.625-6.708 5.625V20C19.139 20 23 16.642 23 12.5S19.139 5 14.375 5h-5.75C3.862 5 0 8.358 0 12.5c0 3.433 2.653 6.327 6.273 7.218v-1.935c-2.545-.773-4.356-2.781-4.356-5.283 0-3.222 3.003-5.625 6.708-5.625h5.75c3.705 0 6.708 2.403 6.708 5.625"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.917 19.5c0-3.222 3.003-5.625 6.708-5.625V12C12.861 12 9 15.358 9 19.5s3.862 7.5 8.625 7.5h5.75C28.139 27 32 23.642 32 19.5c0-3.433-2.653-6.327-6.273-7.218v1.935c2.545.773 4.356 2.781 4.356 5.283 0 3.222-3.003 5.625-6.708 5.625h-5.75c-3.705 0-6.708-2.403-6.708-5.625"
})));
export default SvgLink;